import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login'
import Scoring from './views/Scoring'
import Results from './views/Results'
import Account from './views/Account'
import Inquiry from './views/Inquiry'

import {PathDispatcher} from './modules/dispatcher'

Vue.use(Router)

let customRouter = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      redirect: {name: 'scoring'}
    },
    {
      path: '/scoring',
      name: 'scoring',
      component: Scoring,
      meta: {requiresAuth: true}
    },
    {
      path: '/results',
      name: 'results',
      component: Results,
      meta: {requiresAuth: true}
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: {requiresAuth: true}
    },
    {
      path: '/inquiry',
      name: 'inquiry',
      component: Inquiry,
      meta: {requiresAuth: true}
    }
  ]
})

customRouter.beforeEach((to, from, next) => {
  let $session = customRouter.app.$session

  if (to.matched.some(record => record.meta.requiresAuth) && !$session.exists()) {
    next({path: '/login', query: {redirect: to.fullPath}})
  } else {
    Vue.prototype.$pathDispatcher = new PathDispatcher()
    next()
  }
})

export default customRouter



// WEBPACK FOOTER //
// ./src/router.js